// action-plans.ts — Endpoints plans d'action (conteneurs + phases/volets + liens).
import { downloadBlob, req } from './_internals.js';

export const actionPlansApi = {
  // Plans (lecture/écriture gardées par action_plans.read / .write côté backend).
  getActionPlans: () => req('GET', '/action-plans'),
  getActionPlan: (id: number | string) => req('GET', '/action-plans/' + id),
  createActionPlan: (d: unknown) => req('POST', '/action-plans', d),
  updateActionPlan: (id: number | string, d: unknown) => req('PUT', '/action-plans/' + id, d),
  deleteActionPlan: (id: number | string) => req('DELETE', '/action-plans/' + id),

  // Phases / volets.
  createPhase: (planId: number | string, d: unknown) =>
    req('POST', '/action-plans/' + planId + '/phases', d),
  updatePhase: (phaseId: number | string, d: unknown) =>
    req('PUT', '/action-plans/phases/' + phaseId, d),
  deletePhase: (phaseId: number | string) => req('DELETE', '/action-plans/phases/' + phaseId),

  // Transforme une phase intelligente en phase statique : fige les actions
  // résolues en liens manuels et désactive le recalcul automatique.
  materializePhase: (phaseId: number | string) =>
    req('POST', '/action-plans/phases/' + phaseId + '/materialize'),

  // Liens action ↔ phase.
  linkActionToPhase: (phaseId: number | string, actionId: number | string) =>
    req('POST', '/action-plans/phases/' + phaseId + '/actions/' + actionId),
  unlinkActionFromPhase: (phaseId: number | string, actionId: number | string) =>
    req('DELETE', '/action-plans/phases/' + phaseId + '/actions/' + actionId),

  // KPI d'une phase : la consultation déclenche le recalcul du jour (write-on-read)
  // côté backend, puis renvoie { phase, history[] } pour les graphes.
  getPhaseKpis: (phaseId: number | string) =>
    req('GET', '/action-plans/phases/' + phaseId + '/kpis'),

  // Combo de filtre « Plans d'action » de #actions : référentiel MINIMAL des
  // phases (id/code/title + plan), OUVERT à tout utilisateur authentifié comme
  // `/structures/options`. Indépendant de `action_plans.read`.
  getPhasesForFilter: () => req('GET', '/action-plans/phases/options'),

  // Export multi-onglets d'un plan (XLSX/JSON via downloadBlob). Les actions
  // confidentielles non visibles sont MASQUÉES côté backend.
  exportActionPlan: (planId: number | string, payload: unknown): Promise<Blob> =>
    downloadBlob('/action-plans/' + planId + '/export', payload),
};
